import { FC, useId } from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, RadioGroupProps } from '@mui/material';

export interface Props extends RadioGroupProps {
  label: string;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
  hasError?: string;
}

const OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

/**
 * YesNo
 */
const YesNo: FC<Props> = ({ value, label, disabled, onChange, error, required, hasError, ...props }) => {
  const id = useId();

  const innerOnChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    if (onChange) {
      const form = event.target.form;
      const input = form?.querySelector('input[type="text"]');
      if (hasError === value) {
        input?.setAttribute('required', 'required');
      } else {
        input?.removeAttribute('required');
      }
      onChange(event, value);
    }
  };
  return (
    <FormControl disabled={disabled}>
      <FormLabel id={id}>{label}</FormLabel>
      <RadioGroup value={value} onChange={innerOnChange} {...props}>
        {OPTIONS.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            sx={{
              '& .MuiFormControlLabel-asterisk': {
                display: 'none',
              },
            }}
            control={
              <Radio
                required={required}
                sx={{
                  color: error && 'error',
                  '&.Mui-checked': {
                    color: error && 'red',
                  },
                }}
              />
            }
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default YesNo;
